import React from 'react';
import { useIsMobile } from '@/lib/utils/useIsMobile';
import { Dashboard } from '@/pages/dashboard';
import { MobileDashboard } from '@/pages/MobileDashboard';
import PWAInstallPrompt from './PWAInstallPrompt';

export function ResponsiveDashboard() {
  const isMobile = useIsMobile();
  
  console.log('ResponsiveDashboard: isMobile =', isMobile);
  
  if (isMobile) {
    console.log('ResponsiveDashboard: Using MobileDashboard');
    return (
      <>
        <PWAInstallPrompt />
        <MobileDashboard />
      </>
    );
  }
  
  console.log('ResponsiveDashboard: Using Desktop Dashboard');
  return (
    <>
      <PWAInstallPrompt />
      <Dashboard />
    </>
  );
}